import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { BsFillInfoCircleFill } from 'react-icons/bs';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    background-color: ${(props) => props.theme.color.bg.primary};
  }
`;

// wide: cadastro em etapas (out/2026) — os cards de plano não cabem em 400px
export const Content = styled.div<{ wide?: boolean }>`
  display: flex;
  width: ${(props) => (props.wide ? 'min(880px, 100%)' : '400px')};
  margin: ${(props) => (props.wide ? '32px 0' : '0')};
  flex-direction: column;
  /* text-align: center; */
  padding: 30px;

  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    padding: 24px 16px;
  }
  border-radius: 3px;
  background: ${(props) => props.theme.color.bg.primary};
  select {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid ${(props) => props.theme.color.text.tertiary};
    background: ${(props) => props.theme.color.bg.primary};
    box-shadow: 0px 0px 0px 0px #cbdafc;
    height: 48px;
    width: 100%;
    font-size: 16px;
    font-family: Montserrat;
    color: #999999;
    &::placeholder {
      color: #999999;
    }
    &:focus {
      outline: none;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
`;

export const LogoImg = styled.img`
  width: 120px;
  height: auto;
`;

export const Body = styled.div`
  span {
    color: ${(props) => props.theme.color.text.disabled};

    b {
      cursor: pointer;
      text-decoration: underline;
      font-weight: ${(props) => props.theme.font.body.weight.bold};
      color: ${(props) => props.theme.color.text.secondary};
    }
  }
`;

export const SocialSignUpContainer = styled.div``;

export const SocialOrContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 0;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
  color: ${(props) => props.theme.color.text.disabled};
`;

export const SocialLogoImg = styled.img`
  width: 24px;
  height: auto;
`;

const SocialButton = styled.div`
  height: 38px;
  border-radius: 3px;
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
  color: ${(props) => props.theme.color.text.primary};
  padding: 0 8px;
  cursor: pointer;

  div {
    &:nth-child(1) {
      display: flex;
      align-items: center;
    }
    &:nth-child(2) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const GoogleButton = styled(SocialButton)`
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => props.theme.color.ui.shade2};
`;

export const FacebookButton = styled(SocialButton)`
  margin-top: 20px;
  background-color: #4267b2;
  color: #fff;
`;

export const Footer = styled.div`
  width: 100%;
  margin-top: 25px;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-top: 1px solid #e6e6e6; */
  span {
    color: ${(props) => props.theme.color.text.disabled};
  }
`;

export const Link = styled(RouterLink)`
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.bold};
  line-height: ${(props) => props.theme.font.body.lineHeight.regular};
  color: ${(props) => props.theme.color.text.secondary};
`;

export const Button = styled.button`
  width: 100%;
  margin-top: 20px;
  height: 38px;
  background-color: ${(props) => props.theme.color.ui.primary};
  color: ${(props) => props.theme.color.text.inverse};
  border-radius: 3px;
  border: none;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    opacity: 0.95;
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const WarnIcon = styled(BsFillInfoCircleFill)`
  width: 20px;
  height: 14px;
`;

export const PasswordRules = styled.ul`
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
`;

export const PasswordRuleItem = styled.li<{ ok: boolean }>`
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  line-height: 1.5;
  color: ${(props) =>
    props.ok ? props.theme.color.ui.success : props.theme.color.text.disabled};
`;
